<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1423 1.3125H13.0728L8.85635 6.13047L13.8165 12.6875H9.93369L6.89033 8.71172L3.41221 12.6875H1.479L5.98799 7.5332L1.23291 1.3125H5.21416L7.96221 4.94648L11.1423 1.3125ZM10.4642 11.5336H11.5333L4.63174 2.40625H3.4833L10.4642 11.5336Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#000000',
  },
});
</script>
